module.exports = __webpack_public_path__ + "static/media/audio_file.dc031305.svg";